module.exports = __webpack_public_path__ + "static/media/thumb.7fd8058f.jpg";